type BuildUrlOptions = {
  origin?: string;
  path: string;
  queries?: Record<string, string | boolean | null | undefined>;
};

export const buildUrl = (options: BuildUrlOptions): string => {
  if (options.origin) {
    if (options.origin.match(/\/$/)) {
      throw new Error('URL origin must not have trailing slash.');
    }
  }

  if (!options.path.match(/^\//)) {
    throw new Error('URL path must have leading slash.');
  }

  const queries = options.queries || {};
  const queryEntries = Object.keys(queries)
    .filter(key => !!queries[key])
    .map(key => `${key}=${encodeURIComponent(queries[key] as string)}`);

  if (queryEntries.length > 0) {
    return `${options.origin || ''}${options.path}?${queryEntries.join('&')}`;
  } else {
    return `${options.origin || ''}${options.path}`;
  }
};
